import React from "react";
import {Skeleton} from "primereact/skeleton";
import {usePolicyTracking} from "../../hooks/usePolicyTracking";
import SectionHeader from "../../../../components/ui/SectionHeader";

import EasipolPolicyDisplay from './displays/EasipolPolicyDisplay';
import PendingApplicationPolicyDisplay from './displays/PendingApplicationPolicyDisplay';
import NewApplicationPolicyDisplay from './displays/NewApplicationPolicyDisplay';
import NewLifeApplicationPolicyDisplay from './displays/NewLifeApplicationPolicyDisplay';

const renderTrackResponse = (apiResponse, policyDisplayKey, {updateSelectedPolicy}) => {
    if (
        apiResponse?.responseBody &&
        !Array.isArray(apiResponse.responseBody) &&
        apiResponse.responseBody.policyApplicationRequestId
    ) {
        return (
            <div className="row dl-equal-row">
                <div className="col-xxl-4 col-xl-4 col-lg-12 dl-equal-col">
                    {/* <News /> */}
                </div>
                <div className="col-xxl-8 col-xl-8 col-lg-12 dl-equal-col">
                    <PendingApplicationPolicyDisplay applicationDetail={apiResponse.responseBody}/>
                </div>
            </div>
        );
    }

    if (apiResponse?.responseBody && Array.isArray(apiResponse.responseBody) && apiResponse.responseBody.length > 0) {
        return (
            <EasipolPolicyDisplay key={policyDisplayKey} policyList={apiResponse.responseBody}
                                  policyDisplayKey={policyDisplayKey} apiResponse={apiResponse}
                                  updateSelectedPolicy={updateSelectedPolicy}/>
        );
    }

    return <NewLifeApplicationPolicyDisplay applicationDetail={apiResponse.responseBody}/>;
};

const BalanceWidget = () => {
    const {policyDisplay, loading} = usePolicyTracking(renderTrackResponse);

    return (
        <div className="w-full">
                {loading ? (
                    <div className="border border-base-300 rounded-xl p-4 bg-base-100">
                        <div className="flex mb-3">
                            <Skeleton shape="circle" size="4rem" className="mr-2"></Skeleton>
                            <div>
                                <Skeleton width="10rem" className="mb-2"></Skeleton>
                                <Skeleton width="5rem" className="mb-2"></Skeleton>
                                <Skeleton height=".5rem"></Skeleton>
                            </div>
                        </div>
                        <Skeleton width="100%" height="150px"></Skeleton>
                        <div className="flex justify-between mt-3">
                            <Skeleton width="4rem" height="2rem"></Skeleton>
                            <Skeleton width="4rem" height="2rem"></Skeleton>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="w-full">
                            <SectionHeader title="Quick Access Options"/>
                            {policyDisplay}
                        </div>
                        <div className="mt-8 w-full">
                            <NewApplicationPolicyDisplay/>
                        </div>
                    </>
                )}
            </div>
    );
};

export default BalanceWidget;
